(function () {
  'use strict';

  const form = document.getElementById('localization_form');
  const countrySelect = form?.querySelector('[name="country_code"]');
  const returnTo = form?.querySelector('[name="return_to"]');
  const params = new URLSearchParams(window.location.search);
  const shopify = window.Shopify;
  if (!form || !countrySelect || !returnTo || shopify?.designMode || shopify?.visualPreviewMode) return;
  if (params.has('preview_theme_id') || params.has('country') || (window.theme?.info?.role && window.theme.info.role !== 'main')) return;

  const visitKey = 'hsg-country-detection-v1';
  try {
    if (sessionStorage.getItem(visitKey)) return;
    sessionStorage.setItem(visitKey, 'checked');
  } catch (_) {
    return;
  }

  const controller = new AbortController();
  let active = true;
  const cancel = () => {
    active = false;
    controller.abort();
  };
  const timeout = window.setTimeout(cancel, 2000);
  const onManualLocalization = (event) => {
    if (event.target.closest('form[action*="/localization"]')) cancel();
  };
  const manualEvents = ['submit', 'change', 'theme:popout:click'];
  manualEvents.forEach((name) => document.addEventListener(name, onManualLocalization, true));
  window.addEventListener('pagehide', cancel, { once: true });

  fetch('/browsing_context_suggestions.json', { signal: controller.signal })
    .then((response) => response.ok ? response.json() : null)
    .then((data) => {
      const suggested = data?.detected_values?.country?.handle;
      if (!active || !form.isConnected || typeof suggested !== 'string') return;
      if (suggested === form.dataset.currentCountry || !Array.from(countrySelect.options).some((option) => option.value === suggested)) return;
      const countryQuery = `${window.location.search ? '&' : '?'}country=${encodeURIComponent(suggested)}`;
      returnTo.value = window.location.pathname + window.location.search + countryQuery + window.location.hash;
      countrySelect.value = suggested;
      form.submit();
    })
    .catch(() => {})
    .finally(() => {
      window.clearTimeout(timeout);
      manualEvents.forEach((name) => document.removeEventListener(name, onManualLocalization, true));
      window.removeEventListener('pagehide', cancel);
    });
})();
